export default "__VITE_ASSET__CddvQ6z$__"